import React from "react";
import { Link } from "react-router-dom";
import { MdCancel } from "react-icons/md";
import Navbar from "../Layout/Navbar/Navbar";

const Failed = () => {
  return (
    <div>
      <div className="sticky top-0 z-100">
        <Navbar />
      </div>
      <div className="success-wrapper">
        <div className="success">
          <p className="icon text-red-600">
            <MdCancel />
          </p>
          <h2 className="text-red-600">Payment Failed!</h2>
          <p className="email-msg">
            Unfortunately, your transaction could not be completed.
          </p>
          <p className="description">
            Please try again or contact{" "}
            <a className="email" href="mailto:info@azamdeal.com">
              info@azamdeal.com
            </a>{" "}
            for assistance.
          </p>
          <Link to="/">
            <button
              type="button"
              width="300px"
              className="hover:bg-red-700 bg-red-600 p-2 text-white rounded-md font-semibold mt-5"
            >
              Back to Home
            </button>
          </Link>
        </div>
      </div>
      <div className="border-t-2 mt-10 md:mt-16 lg:mt-16">
        <div className="mx-auto max-w-screen-2xl px-3 sm:px-10 flex justify-center py-4">
          <h2 className="text-sm text-gray-500 font-semibold leading-6">
            Copyright 2022 @{" "}
            <Link to="https://themeforest.net/user/htmllover">
              <span
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#008000] font-bold"
              >
                AZAMDEAL
              </span>
            </Link>
            , All rights reserved.
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Failed;
